import request from '@/utils/request'
import { getCMSUrl, getLinkUrl } from './config'
type dataType = any
export default {
    // 获取聊天室信息
    getChatInfo(data: dataType): Promise<{
        response?: Response
    }> {
        return request({
            url: getCMSUrl + '/private_chat/info?token=' + data.token + '&type=' + data.type,
            method: 'post',
            data,
            headers: {
                'content-type': 'application/x-www-form-urlencoded'
            }
        })
    },
    // 获取聊天列表
    getChatMessage(data: dataType): Promise<{
        response?: Response
    }> {
        const params = new URLSearchParams()
        Object.keys(data).forEach(key => params.append(key, data[key]))
        return request({
            url: getCMSUrl + '/private_chat/messages',
            method: 'post',
            data: params,
            headers: {
                'content-type': 'application/x-www-form-urlencoded'
            }
        })
    },
    //用户聊天上线
    setOnline(data: dataType): Promise<{
        response?: Response
    }> {
        const params = new URLSearchParams()
        Object.keys(data).forEach(key => params.append(key, data[key]))
        return request({
            url: getCMSUrl + '/private_chat/set_online',
            method: 'post',
            data: params,
            headers: {
                'content-type': 'application/x-www-form-urlencoded'
            }
        })
    },
    //老师获取用户聊天列表
    getChats(data: dataType): Promise<{
        response?: Response
    }> {
        const params = new URLSearchParams()
        Object.keys(data).forEach(key => params.append(key, data[key]))
        return request({
            url: getCMSUrl + '/private_chat/chats',
            method: 'post',
            data: params,
            headers: {
                'content-type': 'application/x-www-form-urlencoded'
            }
        })
    },
    //发送聊天信息
    getSendMsg(data: dataType): Promise<{
        response?: Response
    }> {
        const params = new URLSearchParams()
        Object.keys(data).forEach(key => params.append(key, data[key]))
        return request({
            url: getCMSUrl + '/private_chat/send_msg',
            method: 'post',
            data: params,
            headers: {
                'content-type': 'application/x-www-form-urlencoded'
            }
        })
    },
    //撤回聊天信息
    recallMsg(data: dataType): Promise<{
        response?: Response
    }> {
        const params = new URLSearchParams()
        Object.keys(data).forEach(key => params.append(key, data[key]))
        return request({
            url: getCMSUrl + '/private_chat/recall_msg',
            method: 'post',
            data: params,
            headers: {
                'content-type': 'application/x-www-form-urlencoded'
            }
        })
    },
    //上传图片
    getUpload(data: dataType): Promise<{
        response?: Response
    }> {
        // request 拦截器会自动检测 FormData 并设置正确的 Content-Type
        return request({
            url: getLinkUrl + '/kf/chat/upload',
            method: 'post',
            data
        })
    }

}